import { useItem } from "../../../fetch/fetch.item";
import { EMPTY_ITEM } from "../../../const/typeDefault/Item";
import ErrMessage from "../../core/ErrMessage";
import { Link } from "react-router-dom";
import IfItemOwner from "../coditions/IfItemOwner.tsx";
import { ROUTE_ADD_ITEM } from "../../../const/routes.ts";
import FetchCategory from "../../category/fetch/FetchCategory.tsx";

const EditItem = ({
  itemId,
  children,
  fallback,
}: {
  itemId: string;
  children: React.ReactNode;
  fallback: React.ReactNode;
}) => {
  const { item, isLoading, isError } = useItem(itemId, EMPTY_ITEM);
  if (isLoading) return fallback;
  if (isError) return <ErrMessage message={isError} />;
  return (
    <IfItemOwner itemId={itemId} fallback={fallback}>
      <FetchCategory slug={item.category} fallback={fallback}>
        {(category) => (
          <Link to={ROUTE_ADD_ITEM(category.slug, item._id)} replace={true}>
            {children}
          </Link>
        )}
      </FetchCategory>
    </IfItemOwner>
  );
};
export default EditItem;
